import React, { Component } from 'react';

export default class NONACRCampaignSetup extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <div>Hello, I am that tab</div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/containers/non-acr-campaign-setup/index.js
 **/